import React from "react";
import {
  Home,
  Truck,
  Building2,
  Armchair,
  PackageCheck,
  Package,
  Sofa,
  Warehouse,
  MapPin,
} from "lucide-react";
import { SERVICES, waHref } from "../lib/site";

const ICONS = { Home, Truck, Building2, Armchair, PackageCheck, Package, Sofa, Warehouse, MapPin };

const COLOR_MAP = {
  blue: { bg: "bg-blue-50", text: "text-blue-700", ring: "ring-blue-200", chip: "bg-blue-600" },
  orange: { bg: "bg-orange-50", text: "text-orange-700", ring: "ring-orange-200", chip: "bg-orange-600" },
  yellow: { bg: "bg-yellow-50", text: "text-yellow-700", ring: "ring-yellow-200", chip: "bg-yellow-500" },
  red: { bg: "bg-red-50", text: "text-red-700", ring: "ring-red-200", chip: "bg-red-600" },
};

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-bold uppercase tracking-wider">
            Our Services
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit" }}>
            Har Type ka <span className="text-blue-800">Shifting Solution</span>
          </h2>
          <p className="mt-4 text-slate-600">
            Home se lekar office tak — pura Delhi NCR coverage with safe, fast aur affordable shifting services.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.icon] || Truck;
            const c = COLOR_MAP[s.color] || COLOR_MAP.blue;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${idx}`}
                className="group relative bg-white rounded-2xl border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
              >
                <div className={`absolute -top-px left-6 right-6 h-[3px] ${c.chip} rounded-b-full opacity-0 group-hover:opacity-100 transition`} />
                <div className={`w-14 h-14 rounded-xl ${c.bg} ring-4 ${c.ring} grid place-items-center mb-5 group-hover:scale-110 transition`}>
                  <Icon className={c.text} size={26} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>
                  {s.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <a
                  href={waHref(`Hi, I need ${s.title} service. Please share the quote.`)}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`service-enquire-${idx}`}
                  className={`mt-5 inline-flex items-center gap-1.5 text-sm font-semibold ${c.text} hover:underline`}
                >
                  Enquire on WhatsApp →
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
